import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { is, path, defaultTo, compose } from 'ramda';

import ActionButton from 'components/ActionButton';

import { view, detail } from './MedicationSearch.less';

const safeValue = (obj, value) => compose(defaultTo(null), path([value]))(obj);
const safeArray = (obj, value) => compose(defaultTo([]), path([value]))(obj);

const MedicationRow = ({ label, value }) => (
  <Row>
    <Col xs={4}>{label}</Col>
    <Col xs={8}>
      <b>{value}</b>
    </Col>
  </Row>
);

const MedicationSearch = ({ onDialogToggle, value, localeMessage, viewMode = false }) => (
  <div className={view}>
    {is(Object, value) && (
      <div className={detail}>
        <MedicationRow label={localeMessage('medication.labels.name')} value={safeValue(value, 'name')} />
        <MedicationRow label={localeMessage('medication.labels.dosageForm')} value={safeValue(value, 'dosageForm')} />
        <MedicationRow
          label={localeMessage('medication.labels.substances')}
          value={
            Array.isArray(value.substances) ? safeArray(value, 'substances').join(', ') : safeValue(value, 'substances')
          }
        />
      </div>
    )}
    {!viewMode && (
      <Row middle="xs">
        <Col xs>
          <ActionButton
            localeId={is(Object, value) ? 'medication.labels.changeMedication' : 'medication.labels.chooseMedication'}
            secondary
            border
            long
            onClick={onDialogToggle}
          />
        </Col>
      </Row>
    )}
  </div>
);

MedicationRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

MedicationSearch.propTypes = {
  onDialogToggle: PropTypes.func.isRequired,
  localeMessage: PropTypes.func.isRequired,
  value: PropTypes.object,
  viewMode: PropTypes.bool,
};

export default MedicationSearch;
